<template>
    <div class="u-padding">
        <table class="table vps-overview__table" cellspacing="0" dusk="insert-server">
            <thead class="vps-overview__table-head">
                <tr>
                    <th>{{ trans('page.vps.table.status') }}</th>
                    <th>{{ trans('page.vps.table.name') }}</th>
                    <th>{{ trans('page.vps.table.specification') }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <vps-server
                        v-for="server in servers"
                        :server="server"
                        :domain="domain"
                        :updating="updating"
                        :subscription="subscription"
                />
            </tbody>
        </table>
    </div>
</template>

<script>
import VpsServer from './VpsServer.vue';
import '../styles/_vps-overview.scss';

export default {
    components: {
        VpsServer
    },
    props: {
        domain: {
            type: String,
            required: true
        },
        servers: {
            type: Array,
            default: () => []
        },
        updating: {
            type: Boolean,
            default: false
        },
        subscription: {
            type: Object,
            required: true
        }
    },
    methods: {
        /**
         * Remove server from list
         */
        removeServerFromList(serverid) {
            let index = this.servers.findIndex(server => server.id === serverid);

            this.servers.splice(index, 1);
        }
    },
};
</script>
